import { z } from 'zod'
import { api } from '@/lib/api/client'

/**
 * `ChannelPhoneProfileResponse` do back (`GET /whatsapp/channels/{id}/phone-profile`): o perfil do número que
 * serve o canal, e SÓ o perfil — allowlist explícita no back (`extra='forbid'`), nunca o `public_dump()`.
 *
 * `z.object` sem `.passthrough()` de propósito: o Zod 4 descarta chave desconhecida, então campo técnico que um
 * dia vazasse (qualidade, limite, health, `profile_picture_url`, `id` da Meta) para aqui e não chega à tela.
 * Os campos de business profile vêm do `whatsapp_business_profile[0]` do espelho; lista vazia no back = `None`.
 */
export const ChannelPhoneProfileSchema = z.object({
  verified_name: z.string().nullable(),
  display_phone_number: z.string().nullable(),
  about: z.string().nullish(),
  description: z.string().nullish(),
  address: z.string().nullish(),
  email: z.string().nullish(),
  vertical: z.string().nullish(),
  websites: z.array(z.string()),
})
export type ChannelPhoneProfile = z.infer<typeof ChannelPhoneProfileSchema>

/**
 * Perfil do número do canal. Exige `channels:profile:read` E o canal no escopo de quem pede (o
 * `@validate_access` do back checa o `channel_id` contra a dimensão `channels`): fora do escopo é 403; canal
 * inativo/inexistente ou sem número é 404. Lê o espelho do banco (sem Graph). O erro sobe como `ApiError`
 * (interceptor de `@/lib/api/client`, sem toast); quem degrada pra "sem número" é `useChannelIdentity`.
 */
export async function getChannelPhoneProfile(channelId: string): Promise<ChannelPhoneProfile> {
  const { data } = await api.get<unknown>(`/whatsapp/channels/${channelId}/phone-profile`)
  return ChannelPhoneProfileSchema.parse(data)
}
